import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import logo from "../images/logo.png";
import mlogo from "../images/mobileLogo.png";
import search from "../images/search.svg";
import wallet from "../images/wallet.svg";
import light from "../images/light.svg";
import dark from "../images/dark.svg";
import darksearch from "../images/darksearch.svg";
import login from "../images/login.svg";
import Register from "./Register";
import { User, History, TrendingUp, Power } from "lucide-react";
import Login from "./Login";
import {
  logout,
  selectLoginModal,
  selectRegisterModal,
  selectUser,
  setLoginModal,
  setResetPasswordModal,
  setRegisterModal,
  selectResetPasswordModal,
} from "../store/auth-slice";
import { DepositModal } from "./DepositModal";
import { CURRENCY } from "../constants";
import { formatAmount } from "../utils";
import { socketService } from "../store/socket";
import PasswordReset from "./PasswordReset";
import { useTheme } from "../context/ThemeContext";
const menuItems = [
  { label: "Sports", path: "/sports" },
  { label: "Live", path: "/" },
  { label: "Casino", path: "/casino" },
  { label: "Jackpots", path: "/" },
  { label: "Livescore", path: "/" },
  { label: "Promotions", path: "/" },
];

const Header = () => {
  // Toggle Register / Login Modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenRGS, setIsModalOpenRGS] = useState(false);
  const [depositAmount, setDepositAmount] = useState("");
  const [openDepositModal, setOpenDepositModal] = useState(false);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const user = useSelector(selectUser);
  const isLoginModalOpen = useSelector(selectLoginModal);
  const isResetPasswordModalOpen = useSelector(selectResetPasswordModal);
  const isRegistrationModalOpen = useSelector(selectRegisterModal);
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const { isDarkMode, toggleTheme } = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const openModal = () => {
    dispatch(setLoginModal(true));
    setIsModalOpen(true);
  };
  const closeModal = () => {
    dispatch(setLoginModal(false));
    setIsModalOpen(false);
  };
  // Logout handler
  const handleLogout = () => {
    dispatch(logout());
  };
  const openModalRGS = () => {
    dispatch(setRegisterModal(true));
    setIsModalOpenRGS(true);
  };
  const handleDeposit = (amount) => {
    // handle deposit
    setOpenDepositModal(false);
    setDepositAmount("");
  };
  const closeModalRGS = () => {
    dispatch(setRegisterModal(false));
    setIsModalOpenRGS(false);
  };
  const closeResetPasswordModal = () => {
    dispatch(setResetPasswordModal(false));
  };
  // Dark mode / Light mode state
  const [isCollapsed, setIsCollapsed] = useState(false);
  // const [isDarkMode, setIsDarkMode] = useState(false);
  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };
  // const toggleTheme = () => {
  //   // Toggle the dark mode theme
  //   const newTheme = isDarkMode ? "light" : "dark";
  //   localStorage.setItem("theme", newTheme);

  //   // Apply the theme to the document element
  //   document.documentElement.classList.toggle("dark", newTheme === "dark");

  //   // Update the state
  //   setIsDarkMode(!isDarkMode);
  // };
  useEffect(() => {
    if (user && user.id) {
      // Connect to socket when component mounts
      socketService.connect(user.id);

      // Initial balance load
      // dispatch(refreshBalance(provider));
    }

    return () => {
      // Disconnect when component unmounts (or move to App level)
      // socketService.disconnect();
    };
  }, [user]);
  // useEffect(() => {
  //   // Check localStorage or OS preference on page load
  //   const savedTheme = localStorage.getItem("theme");
  //   if (savedTheme === "dark") {
  //     setIsDarkMode(true);
  //     document.documentElement.classList.add("dark");
  //   } else if (savedTheme === "light") {
  //     setIsDarkMode(false);
  //     document.documentElement.classList.remove("dark");
  //   } else {
  //     // Handle default based on system preference
  //     const prefersDarkMode = window.matchMedia(
  //       "(prefers-color-scheme: dark)"
  //     ).matches;
  //     setIsDarkMode(prefersDarkMode);
  //     document.documentElement.classList.toggle("dark", prefersDarkMode);
  //   }
  // }, []);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isProfileDropdownOpen && !event.target.closest(".profile-dropdown")) {
        setIsProfileDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isProfileDropdownOpen]);

  useEffect(() => {
    if (isCollapsed) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
  }, [isCollapsed]);

  const AuthButtons = ({ isMobile = false }) => {
    if (isAuthenticated) {
      return (
        <>
          {isMobile ? (
            <>
              <button className="bg-yellow border-2  border-transparent hover:border-yellow rounded-sm md:rounded-5px flex gap-1 items-center justify-between p-1 sm:p-2 text-[8px] sm:text-xs font-medium text-darkGreen hover:text-yellow hover:bg-transparent group">
                <UserIcon />
                <span>{formatAmount(user.balance, "KES", "sw-KE")}</span>
              </button>
              {/* DEPOSIT BUTTON */}
              <button
                onClick={() => setOpenDepositModal(true)}
                className="py-1 px-1 sm:p-2 text-center bg-yellow border-2 border-transparent rounded-sm md:rounded-5px text-[8px] sm:text-xs leading-normal font-medium transition-all duration-300 hover:bg-transparent hover:border-yellow hover:text-yellow tracking-tighter"
              >
                DEPOSIT
              </button>
              <div className="relative profile-dropdown">
                <button
                  onClick={() =>
                    setIsProfileDropdownOpen(!isProfileDropdownOpen)
                  }
                  className={`md:w-[48px] md:h-[50px] flex justify-center items-center py-1 px-1 sm:p-2 bg-white dark:bg-darktitleColor rounded-sm md:rounded-5px transition-all duration-[0.3s] hover:bg-gray-100 dark:hover:bg-[#4F5F75]`}
                >
                  <User className={`text-darkblue dark:text-white size-4`} />
                </button>

                {isProfileDropdownOpen && (
                  <div className="absolute right-0 mt-2 w-56 rounded-lg overflow-hidden shadow-lg z-50 bg-white dark:bg-darktitleColor border border-gray-200 dark:border-gray-700">
                    <div className="py-2">
                      {/* Menu Items */}
                      <div className="px-4 py-3 bg-gray-100 dark:bg-bluedarkmode flex justify-between items-center">
                        <span className="text-sm text-gray-700 dark:text-white">
                          BALANCE:
                        </span>
                        <span className="text-lg font-semibold text-gray-700 dark:text-white">
                          {formatAmount(user.balance, "KES", "sw-KE")}
                        </span>
                      </div>
                      <button
                        onClick={() => {
                          navigate("/profile");
                          setIsProfileDropdownOpen(false);
                        }}
                        className="w-full flex items-center px-4 py-2.5 text-sm text-gray-700 dark:text-white hover:bg-gray-50 dark:hover:bg-yellow transition-colors duration-150"
                      >
                        <User className="w-4 h-4 mr-3" />
                        MY PROFILE
                      </button>

                      <button
                        onClick={() => {
                          navigate("/transaction");
                          setIsProfileDropdownOpen(false);
                        }}
                        className="w-full flex items-center px-4 py-2.5 text-sm text-gray-700 dark:text-white hover:bg-gray-50 dark:hover:bg-yellow transition-colors duration-150"
                      >
                        <History className="w-4 h-4 mr-3" />
                        TRANSACTION HISTORY
                      </button>

                      <button
                        onClick={() => {
                          navigate("/bet-history");
                          setIsProfileDropdownOpen(false);
                        }}
                        className="w-full flex items-center px-4 py-2.5 text-sm text-gray-700 dark:text-white hover:bg-gray-50 dark:hover:bg-yellow transition-colors duration-150"
                      >
                        <TrendingUp className="w-4 h-4 mr-3" />
                        BET HISTORY
                      </button>

                      {/* Divider */}
                      <div className="my-2 border-t border-gray-200 dark:border-gray-700" />

                      {/* Logout Button */}
                      <button
                        onClick={handleLogout}
                        className="w-full flex items-center px-4 py-2.5 text-sm text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/10 transition-colors duration-150"
                      >
                        <Power className="w-4 h-4 mr-3" />
                        LOGOUT
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </>
          ) : (
            <>
              {/* Balance */}
              <button className="bg-yellow border-2 border-transparent hover:border-yellow rounded-sm rounded-5px flex gap-1 items-center justify-between p-1 sm:p-2 text-[8px] sm:text-xs font-medium text-darkGreen hover:text-yellow hover:bg-transparent group">
                <UserIcon />
                <span>{formatAmount(user.balance, "KES", "sw-KE")}</span>
              </button>
              <button
                onClick={() => setOpenDepositModal(true)}
                className="min-w-[88px] bg-yellow  border-solid border-2 border-transparent rounded-5px inline-flex items-center justify-center p-2 px-2 s18:p-[11px_8px] text-sm s18:text-base !leading-none s18:leading-normal font-medium transition-all duration-300 hover:bg-transparent hover:border-yellow hover:text-yellow"
              >
                DEPOSIT
              </button>
              <div className="relative profile-dropdown">
                <button
                  onClick={() =>
                    setIsProfileDropdownOpen(!isProfileDropdownOpen)
                  }
                  className={`w-[40px] h-[40px] s18:w-[48px] s18:h-[50px] flex justify-center items-center p-2 s18:p-[10px] bg-white dark:bg-darktitleColor rounded-[5px] transition-all duration-[0.3s] hover:bg-gray-100 dark:hover:bg-yellow`}
                >
                  <User
                    className={`text-darkblue dark:text-white size-5 s18:size-[26px]`}
                  />
                </button>

                {isProfileDropdownOpen && (
                  <div className="absolute right-0 mt-2 w-56 rounded-lg overflow-hidden shadow-lg z-50 bg-white dark:bg-darktitleColor border border-gray-200 dark:border-gray-700">
                    <div className="py-2">
                      {/* Menu Items */}
                      <div className="px-4 py-3 bg-gray-100 dark:bg-bluedarkmode flex justify-between items-center">
                        <span className="text-sm text-gray-700 dark:text-white">
                          BALANCE:
                        </span>
                        <span className="text-lg font-semibold text-gray-700 dark:text-white">
                          {formatAmount(user.balance, "KES", "sw-KE")}
                        </span>
                      </div>
                      <button
                        onClick={() => {
                          navigate("/profile");
                          setIsProfileDropdownOpen(false);
                        }}
                        className="w-full flex items-center px-4 py-2.5 text-sm text-gray-700 dark:text-white hover:bg-gray-50 dark:hover:bg-yellow transition-colors duration-150"
                      >
                        <User className="w-4 h-4 mr-3" />
                        MY PROFILE
                      </button>

                      <button
                        onClick={() => {
                          navigate("/transaction");
                          setIsProfileDropdownOpen(false);
                        }}
                        className="w-full flex items-center px-4 py-2.5 text-sm text-gray-700 dark:text-white hover:bg-gray-50 dark:hover:bg-yellow transition-colors duration-150"
                      >
                        <History className="w-4 h-4 mr-3" />
                        TRANSACTION HISTORY
                      </button>

                      <button
                        onClick={() => {
                          navigate("/bet-history");
                          setIsProfileDropdownOpen(false);
                        }}
                        className="w-full flex items-center px-4 py-2.5 text-sm text-gray-700 dark:text-white hover:bg-gray-50 dark:hover:bg-yellow transition-colors duration-150"
                      >
                        <TrendingUp className="w-4 h-4 mr-3" />
                        BET HISTORY
                      </button>

                      {/* Divider */}
                      <div className="my-2 border-t border-gray-200 dark:border-gray-700" />

                      {/* Logout Button */}
                      <button
                        onClick={handleLogout}
                        className="w-full flex items-center px-4 py-2.5 text-sm text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/10 transition-colors duration-150"
                      >
                        <Power className="w-4 h-4 mr-3" />
                        LOGOUT
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </>
      );
    }
    return (
      <>
        {isMobile ? (
          <>
            {" "}
            {/* mobile guest */}
            {/* join now btn */}
            {/* Register button */}
            <button
              onClick={openModalRGS}
              className="py-1.5 px-2.5 sm:py-2 sm:px-3 md:py-2.5 md:px-4 text-center bg-yellow border-2 border-transparent rounded-sm md:rounded-5px text-[10px] sm:text-xs md:text-sm leading-normal font-medium transition-all duration-300 hover:bg-transparent hover:border-yellow hover:text-yellow tracking-tighter whitespace-nowrap"
            >
              REGISTER
            </button>
            {/* Login button */}
            <button
              onClick={openModal}
              className="max-md:dark:hover:bg-white max-md:hover:bg-white max-md:dark:bg-white w-fit bg-white shadow-inputshadow border-2 border-transparent rounded-sm md:rounded-5px py-1.5 px-2.5 sm:py-2 sm:px-3 md:py-2.5 md:px-4 text-[10px] sm:text-xs md:text-sm leading-normal font-medium transition-all duration-300 dark:bg-darktitleColor dark:text-darkblue hover:opacity-80 whitespace-nowrap"
            >
              LOGIN
            </button>
          </>
        ) : (
          <>
            {/* large screens guest buttons */}
            <button
              onClick={openModalRGS}
              className="min-w-[88px] bg-yellow  border-solid border-2 border-transparent rounded-5px inline-flex items-center justify-center p-2 px-2 s18:p-[11px_8px] text-sm s18:text-base !leading-none s18:leading-normal font-medium transition-all duration-300 hover:bg-transparent hover:border-yellow hover:text-yellow"
            >
              REGISTER
            </button>
            {/* login btn */}
            <button
              onClick={openModal}
              className="min-w-[88px] bg-white shadow-inputshadow border-solid border-2 border-transparent rounded-5px inline-flex items-center justify-center p-2 px-2 s18:p-[11px_8px] text-sm s18:text-base !leading-none s18:leading-normal font-medium transition-all duration-300 dark:bg-darktitleColor dark:text-white hover:bg-transparent hover:border-white hover:text-white dark:hover:border-white dark:hover:bg-transparent"
            >
              LOGIN
            </button>
          </>
        )}

        {/* end */}
      </>
    );
  };

  // Mobile menu items for authenticated users
  const AuthenticatedMobileMenuItems = () => {
    if (isAuthenticated) {
      return (
        <>
          <li>
            <Link
              to="/profile"
              className="text-white text-[16px] leading-[150%] font-normal hover:text-yellow transition-all duration-[0.3s]"
              onClick={() => setIsCollapsed(false)}
            >
              My Profile
            </Link>
          </li>
          <li>
            <Link
              to="/transaction"
              className="text-white text-[16px] leading-[150%] font-normal hover:text-yellow transition-all duration-[0.3s]"
              onClick={() => setIsCollapsed(false)}
            >
              Transaction History
            </Link>
          </li>
          <li>
            <Link
              to="/bet-history"
              className="text-white text-[16px] leading-[150%] font-normal hover:text-yellow transition-all duration-[0.3s]"
              onClick={() => setIsCollapsed(false)}
            >
              Bet History
            </Link>
          </li>
        </>
      );
    }
    return null;
  };
  // Render methods
  const renderSearchInput = (isMobile = false) => (
    <div className={`relative ${isMobile ? "max-md:hidden" : ""}`}>
      <input
        type="search"
        className="h-full w-full p-[11px_40px_11px_12px] rounded-5px bg-white dark:bg-darktitleColor 
        shadow-inputshadow placeholder:text-lightblue placeholder:text-base 
        dark:placeholder:text-white dark:text-white"
        placeholder="Search.."
      />
      <img
        src={isDarkMode ? darksearch : search}
        alt="search"
        className="absolute w-[18px] h-[18px] top-1/2 -translate-y-1/2 right-[15px] z-50"
      />
    </div>
  );
  const renderMenuItems = (isMobile = false) => (
    <ul
      className={`
    ${
      isMobile
        ? "flex flex-col items-center justify-center gap-5 overflow-auto"
        : "flex flex-row items-center xl:gap-[18px] s16:gap-[30px]"
    }
  `}
    >
      {menuItems.map((item, index) => (
        <li key={index}>
          <Link
            to={item.path}
            className="text-white text-sm s18:text-base !leading-tight 
            s18:leading-normal font-normal hover:text-yellow 
            transition-all duration-300"
          >
            {item.label}
          </Link>
        </li>
      ))}
    </ul>
  );

  return (
    <>
      <PasswordReset
        isOpen={isResetPasswordModalOpen}
        onClose={closeResetPasswordModal}
      />
      {openDepositModal && (
        <DepositModal
          depositAmount={depositAmount}
          setDepositAmount={setDepositAmount}
          onClose={() => setOpenDepositModal(false)}
          onDeposit={handleDeposit}
        />
      )}
      <section className="sticky top-0 left-0 right-0 w-full bg-bluedarkmode dark:bg-bluedarkmode z-50 py-2 md:py-4">
        <div className="flex max-xl:justify-between items-center w-full max-w-[1780px] mx-auto max-sm:px-[15px] px-[30px]">
          {/* Logo container */}
          <div className="max-[420px]:relative z-[100] flex max-xl:pl-[30px]">
            <Link to="/" className="inline-block">
              <img
                src={logo}
                alt="logo"
                className="object-cover w-10 sm:w-24 md:w-28 lg:w-36 s16:w-[180px] hidden md:block"
              />
              <img
                src={mlogo}
                alt="logo"
                className="object-cover max-md:block hidden w-16 sm:w-24"
              />
            </Link>
          </div>
          {/* added here */}
          <div className="max-xl:flex max-md:items-center xl:hidden gap-1 sm:gap-2">
            <span className="py-1.5 px-2.5 sm:py-2 sm:px-3 h-auto md:hidden max-md:flex justify-center items-center bg-white rounded-sm md:rounded-5px cursor-pointer">
              <img
                src={isDarkMode ? search : search}
                alt="search"
                className="w-4"
              />
            </span>
            {renderSearchInput(true)}

            <AuthButtons isMobile={true} />

            {/* theme btn */}
            <button
              onClick={toggleTheme}
              className="flex justify-center items-center py-1.5 px-2.5 sm:py-2 sm:px-3 md:w-[48px] md:h-[50px] bg-white dark:bg-darktitleColor rounded-sm md:rounded-5px"
            >
              <img
                src={isDarkMode ? dark : light}
                alt={"Light Mode"}
                className="max-md:size-5 md:size-6"
              />
            </button>
          </div>
          {/* big screen links */}
          <div className={`hidden xl:flex justify-between w-full`}>
            <ul className="flex flex-row items-center xl:gap-[18px] s16:gap-[30px] xl:mt-0 mx-auto">
              {menuItems.map((item, index) => (
                <li key={index}>
                  {/* Native scrolling using hash links */}
                  <Link
                    to={item.path}
                    className="text-white text-sm s18:text-base !leading-tight s18:leading-normal font-normal hover:text-yellow transtition-all duration-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="flex gap-[10px]">
              {/* search */}
              {renderSearchInput()}
              <AuthButtons isMobile={false} />
              {/* theme btn */}
              <button
                onClick={toggleTheme}
                className="s18:w-[48px] s18:h-[50px] flex justify-center items-center p-2 s18:p-[10px] bg-white dark:bg-darktitleColor rounded-5px"
              >
                <img
                  src={isDarkMode ? dark : light}
                  alt={"Light Mode"}
                  className="size-5 s18:size-[26px]"
                />
              </button>
            </div>
          </div>
          {/* hamburger toggle button */}
          <Hamburger
            isCollapsed={isCollapsed}
            toggleCollapse={toggleCollapse}
          />
        </div>

        {/* Mobile menu */}
        {/* small screen menubar */}
        {/* Mobile menu sidebar */}
        <div
          className={`fixed top-0 left-0 z-[99] h-full w-3/4 xl:hidden shadow-xl bg-darkblue dark:bg-bluedarkmode transform ${
            isCollapsed ? "translate-x-0" : "-translate-x-full"
          } transition-transform duration-300 ease-in-out`}
        >
          {/* Header with close button */}
          <div className="flex justify-between items-center px-4 py-5 border-b border-gray-700">
            <div className="flex-1"></div>
            <button
              onClick={() => setIsCollapsed(false)}
              className="text-white hover:text-yellow p-2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          {/* Menu items */}
          <div className="overflow-y-auto h-[calc(100%-130px)]">
            <ul className="flex flex-col">
              {menuItems.map((item, index) => (
                <li key={index}>
                  <Link
                    to={item.path}
                    onClick={() => setIsCollapsed(false)}
                    className="flex items-center px-6 py-4 text-white text-sm s18:text-base font-normal hover:text-yellow hover:bg-opacity-10 hover:bg-white transition-all duration-200"
                  >
                    {item.icon && <span className="mr-3">{item.icon}</span>}
                    {item.label}
                  </Link>
                  {/* Divider - don't add after the last item */}
                  {index < menuItems.length - 1 && (
                    <div className="border-b border-gray-700 opacity-50 mx-4"></div>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {!isAuthenticated && (
        <>
          <Login isOpen={isLoginModalOpen} onClose={closeModal} />
          <Register isOpen={isRegistrationModalOpen} onClose={closeModalRGS} />
        </>
      )}
    </>
  );
};

export default Header;

const UserIcon = () => {
  return (
    <img src={wallet} alt="icon" className="w-3 sm:w-4 group-hover:invert" />
  );
};

const Hamburger = ({ toggleCollapse, isCollapsed }) => {
  // Hide the hamburger when sidebar is open
  if (isCollapsed) {
    return null; // Don't render anything when sidebar is open
  }

  return (
    <button
      className="rounded absolute z-[999] xl:hidden transition-opacity duration-300"
      id="navbar-toggle"
      onClick={toggleCollapse}
      aria-label="Open menu"
    >
      <span className="relative w-[18px] max-[420px]:h-[2px] h-[3px] rounded-md bg-yellow block mb-1 duration-300"></span>
      <span className="relative w-[22px] max-[420px]:h-[2px] h-[3px] rounded-md bg-yellow block mb-1 duration-300"></span>
      <span className="relative w-[18px] max-[420px]:h-[2px] h-[3px] rounded-md bg-yellow block duration-300"></span>
    </button>
  );
};
